const insightsAndTipsCodes = {
    EG002: 'EG002',
    EG004: 'EG004',
    EG008: 'EG008',
    EG007: 'EG007',
};

export default insightsAndTipsCodes;
